<template>
  <div class="dblb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="打包状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="缺件" :value="0" />
                <el-option label="完整" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    prop="ordernum"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="包装状态"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" :disable-transitions="true" v-if="scope.row.packtime!==null&&scope.row.packtime!==''&&scope.row.packtime!==undefined">包装完整</el-tag>
                      <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.packtime===null||scope.row.packtime===''||scope.row.packtime===undefined">缺件 {{scope.row.comnum-scope.row.packednum}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.packnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已入库数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#67C23A">{{scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="未入库数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#f56c6c">{{scope.row.packnum-scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="openPackDetails(scope.row)" icon="el-icon-tickets">包装详细</el-button>
                      <!--<el-button size="mini" @click="openDetails(scope.row)" icon="el-icon-link">部件详细</el-button>-->
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="packTitle"
      :visible.sync="editVisible"
      width="1020px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" :rules="editRules" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editForm.xuhao" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="imark">
          <el-select v-model="editForm.imark" style="width: 100px" clearable>
            <el-option label="未入库" value="0"></el-option>
            <el-option label="已入库" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button icon="el-icon-printer" @click="printPaper">打印</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packloading">
        <pl-table
          :key="tableKey"
          height="400px"
          :datas="packTableData"
          :data="packTableData"
          use-virtual
          :pagination-show="false"
          @selection-change="handleSelectionChange"
          size="small"
          :row-height="45">
          <pl-table-column type="selection" :selectable='checkboxT' align="center" width="50"></pl-table-column>
          <pl-table-column prop="produnum" :resizable="false" align="center" label="生产单号" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="ordernum" :resizable="false" align="center" label="订单号" show-overflow-tooltip width="120"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="username" :resizable="false" align="center" label="打包人" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="num" :resizable="false" align="center" label="部件数量" show-overflow-tooltip width="120"></pl-table-column>
          <pl-table-column label="状态" :resizable="false" width="120" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.imark===1">已入库</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.imark===0">未入库</el-tag>
            </template>
          </pl-table-column>
          <pl-table-column label="操作" :resizable="false" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="openDetails(scope.row)" icon="el-icon-link">部件详细</el-button>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
    <el-dialog
      :title="packInfoTitle"
      :visible.sync="editInfoVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editInfoForm" :inline="true" :model="editInfoForm" label-width="70px">
        <el-form-item label="区域" prop="area">
          <el-select v-model="editInfoForm.area" style="width: 200px" filterable clearable>
            <el-option v-for="item in areaList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="type">
          <el-select v-model="editInfoForm.type" style="width: 100px" filterable clearable>
            <el-option v-for="item in typeList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包装状态" prop="mmark">
          <el-select v-model="editInfoForm.mmark" style="width: 100px" clearable>
            <el-option label="未包" value="0"></el-option>
            <el-option label="已包" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="包装" prop="packid">
          <el-select v-model="editInfoForm.packid" style="width: 240px" filterable clearable>
            <el-option
              v-for="item in packList"
              :label="item.packxuhao+' / '+item.packnum"
              :value="item.packid">
              <span style="float: left">{{ '包号：'+item.packxuhao }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.packnum }}</span>
            </el-option>
          </el-select>
        </el-form-item>-->
        <!--<el-form-item label="入库状态" prop="imark">
          <el-select v-model="editInfoForm.imark" style="width: 100px" clearable>
            <el-option label="未入库" value="0"></el-option>
            <el-option label="已入库" value="1"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="关键字" prop="content">
          <el-input v-model="editInfoForm.content" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPackInfo" icon="el-icon-search">搜索</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packInfoloading">
        <pl-table
          :key="tableInfoKey"
          height="400px"
          :datas="packInfoTableData"
          :data="packInfoTableData"
          use-virtual
          :pagination-show="false"
          size="small"
          :row-height="45">
          <pl-table-column prop="bar" :resizable="false" align="center" fixed label="条码" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" fixed label="序号" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="area" :resizable="false" align="center" label="区域" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="type" :resizable="false" align="center" label="分类" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="name" :resizable="false" align="center" label="名称" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="material" :resizable="false" align="center" label="基材" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column :resizable="false" align="center" label="规格" show-overflow-tooltip width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
              <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
              <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
            </template>
          </pl-table-column>
          <pl-table-column prop="color" :resizable="false" align="center" label="颜色" show-overflow-tooltip min-width="130"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="packxuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column label="包装状态" fixed="right" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.mmark===1">已包</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.mmark===0">未包</el-tag>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpDealerPackList, getErpOrderPackList, getErpOrderPackInfoList, getFactoryList, printErpDealerPack} from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'dblb',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      packTitle: '',
      packInfoTitle: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editInfoVisible: false,
      packtypeList: [],
      editForm: {
        packnum: '',
        xuhao: '',
        orderid: '',
        produnum: '',
        imark: ''
      },
      editInfoForm: {
        orderid: '',
        area: '',
        type: '',
        content: '',
        packid: '',
        mmark: '',
        imark: ''
      },
      editRules: {
        ptid: [{ required: true, message: '请选择包装类型', trigger: 'change' }],
        produnum: [{ required: true, message: '请选择订单', trigger: 'change' }]
      },
      tableKey: '',
      multipleSelection: [],
      packTableData: [],
      packloading: false,
      tableInfoKey: '',
      multipleInfoSelection: [],
      packInfoTableData: [],
      packInfoloading: false,
      isfirst: false,
      areaList: [],
      typeList: [],
      packList: [],
      searchForm: {
        type: '',
        search: '',
        factory: '',
        time: ''
      },
      factoryList: [],
      btnLoading: false
    }
  },
  created() {
    this.getData()
    this.getFactoryList()
  },
  methods: {
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
      this.searchForm.search = this.searchForm.search.trim()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.delid,
        type: this.searchForm.type
      }
      getErpDealerPackList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectionInfoChange(val) {
      this.multipleInfoSelection = val
    },
    openPackDetails(row) {
      if (row.bid === 3) {
        this.packTitle = row.ordernum + ' 包装列表'
      } else {
        this.packTitle = row.produnum + ' 包装列表'
      }
      this.editForm.orderid = row.orderid
      this.editForm.produnum = row.produnum
      this.editForm.packnum = ''
      this.editForm.xuhao = ''
      this.editForm.imark = ''
      this.editVisible = true
      this.searchPack()
    },
    openDetails(row) {
      this.packInfoTitle = ' 部件列表'
      this.editInfoForm.orderid = row.orderid
      this.editInfoForm.area = ''
      this.editInfoForm.type = ''
      this.editInfoForm.content = ''
      this.editInfoForm.packid = row.packid
      this.editInfoForm.mmark = ''
      this.editInfoForm.imark = ''
      this.isfirst = true
      this.areaList = []
      this.typeList = []
      this.packList = []
      this.editInfoVisible = true
      this.searchPackInfo()
    },
    searchPackInfo() {
      this.packInfoTableData = []
      this.multipleInfoSelection = []
      this.packInfoloading = true
      const data = {
        orderid: this.editInfoForm.orderid,
        area: this.editInfoForm.area,
        type: this.editInfoForm.type,
        content: this.editInfoForm.content,
        packid: this.editInfoForm.packid,
        mmark: this.editInfoForm.mmark,
        imark: this.editInfoForm.imark
      }
      getErpOrderPackInfoList(data).then(response => {
        this.tableInfoKey = new Date().getTime()
        this.packInfoTableData = response.data
        if (this.isfirst) {
          let areaList = []
          let typeList = []
          let packList = []
          for (let p of response.data) {
            let ishavearea = false
            for (let area of areaList) {
              if (area === p.area) {
                ishavearea = true
                break
              }
            }
            if (!ishavearea) {
              areaList.push(p.area)
            }
            let ishavetype = false
            for (let type of typeList) {
              if (type === p.type) {
                ishavetype = true
                break
              }
            }
            if (!ishavetype) {
              typeList.push(p.type)
            }
            if (p.packid !== null && p.packid !== '' && p.packid !== undefined) {
              let ishavepack = false
              for (let pack of packList) {
                if (pack.packid === p.packid) {
                  ishavepack = true
                  break
                }
              }
              if (!ishavepack) {
                packList.push({ packid: p.packid, packnum: p.packnum, packxuhao: p.packxuhao})
              }
            }
          }
          this.areaList = areaList
          this.typeList = typeList
          this.packList = packList
          this.isfirst = false
        }
        this.packInfoloading = false
      }).catch(() => {
        this.packInfoloading = false
      })
    },
    searchPack() {
      this.packTableData = []
      this.multipleSelection = []
      this.packloading = true
      const data = {
        orderid: this.editForm.orderid,
        packnum: this.editForm.packnum,
        xuhao: this.editForm.xuhao,
        imark: this.editForm.imark
      }
      getErpOrderPackList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    checkboxInfoT(row, rowIndex) {
      if (row.imark === 1 || row.mmark === 0) {
        return false
      } else {
        return true
      }
    },
    checkboxT(row, rowIndex) {
      if (row.imark === 1) {
        return false
      } else {
        return true
      }
    },
    unpack(row) {
      if (row.packid !== null && row.packid !== '' && row.packid !== undefined) {
        this.subUnpack(row.packid)
      } else {
        this.$message.error('包标签号获取失败')
      }
    },
    unpackInfo(row) {
      if (row.obid !== null && row.obid !== '' && row.obid !== undefined) {
        this.subUnpackInfo(row.obid + '')
      } else {
        this.$message.error('部件ID获取失败')
      }
    },
    printPaper() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (this.multipleSelection.length === 0) {
          this.$message.error('请至少选择一个包')
          return false
        }
        const packIds = []
        for (const item of this.multipleSelection) {
          packIds.push(item.packid)
        }
        const data = {
          orderid: this.editForm.orderid,
          packIds: packIds.join(',')
        }
        const loadings = this.$loading({
          lock: true,
          text: '正在打印，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        printErpDealerPack(data).then(response => {
          LODOP.PRINT_INIT('打包打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          loadings.close()
        }).catch(() => {
          loadings.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .dblb-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
